import Component from 'vue-class-component';
import { Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import uuid from 'uuid/v4';

@Component({})
export default class DateFieldWidgetComponent extends Vue {

  @Inject() public $validator: any;
  @Prop(String) public inputName!: string;
  @Prop({ type: String, default: 'payrollForm' }) public formName!: string;
  @Prop(Boolean) public isRequired!: boolean;
  @Prop(Boolean) public showWarningIcon!: boolean;   // to show the icon for the error message
  @Prop(Boolean) public isFutureDate!: boolean;      // to check that the date is valid
  @Prop({ type: Boolean, default: true }) public isDisabled!: boolean;
  @Prop({ type: Boolean, default: true }) public showDay!: boolean;
  @Prop({ type: Boolean, default: true }) public showMonth!: boolean;
  @Prop({ type: Boolean, default: true }) public showYear!: boolean;
  @Prop({ type: [Number, String, Date], required: false }) public dateField;

  // set label for the component (header)
  @Prop(String) private title!: string;
  @Prop(String) private subLabel!: string;
  @Prop(String) private staticInputId!: string;
  @Prop(Boolean) private allowFutureDate: boolean = false;
  @Prop(Number) private maxLength!: number;
  private day: string = '';
  private month: string = '';
  private year: string = '';
  private tempDate: Date = new Date();
  private inputId: string = '';     // create unique id for each component
  private htmlName: string = '';    // the name of the text field
  private maxLen: number = 2;

  get validators(): any {
    const validator: any = {};
    validator.numeric = true;
    if (this.isRequired) {
      validator.required = true;
    }
    return validator;
  }

  public created() {
    this.inputId = this.staticInputId || 'input' + uuid();
    this.htmlName = this.inputName || this.$t(this.title).toString();
    if (this.formName && !this.staticInputId) {
      this.inputId = this.formName + '.' + this.inputId;
    }
  }

  public mounted() {
    if (this.dateField && typeof this.dateField !== 'string') {
      this.initDate(this.dateField);
    }
  }

  public updateDay() {
    if (parseInt(this.day, 10) > 31) {
      this.day = '31';
    }
    if (this.day.length > 1) {
      const month: HTMLInputElement = this.$refs.month as HTMLInputElement;
      month.select();
    }
    if (!this.day.length || parseInt(this.day, 10) < 4) {
      return;
    }
    if (this.showMonth) {
      const month: HTMLInputElement = this.$refs.month as HTMLInputElement;
      month.select();
    } else if (this.showYear) {
      const year: HTMLInputElement = this.$refs.year as HTMLInputElement;
      year.select();
    }
  }

  public onDayKeyup(e) {
    if (e.key === 'Backspace' && !this.day) {
      const month: HTMLInputElement = this.$refs.month as HTMLInputElement;
      month.select();
    }
  }

  public onMonthKeyup(e) {
    if (e.key === 'Backspace' && !this.month) {
      if (!this.year) {
        const day: HTMLInputElement = this.$refs.day as HTMLInputElement;
        day.select();
      } else {
        const year: HTMLInputElement = this.$refs.year as HTMLInputElement;
        year.select();
      }
    }
  }

  public onYearKeyup(e) {
    if (e.key === 'Backspace' && !this.year) {
      const month: HTMLInputElement = this.$refs.month as HTMLInputElement;
      month.select();
    }
  }

  public updateMonth() {
    if (parseInt(this.month, 10) > 12) {
      this.month = '12';
    }
    if (this.month.length > 1) {
      const year: HTMLInputElement = this.$refs.year as HTMLInputElement;
      year.select();
    }
    if ((!this.month.length || parseInt(this.month, 10) < 2)) {
      return;
    }
    if (this.showYear) {
      const year: HTMLInputElement = this.$refs.year as HTMLInputElement;
      year.select();
    }
  }

  public setFocus(): void {
    const day: HTMLInputElement = this.$refs.day as HTMLInputElement;
    day.select();
  }

  @Watch('year')
  public updateYear(current, prev) {
    if (this.year.length > 4) {
      this.year = prev;
    }
    if (current > 9999) {
      this.year = prev;
    }
  }

  public updateValue() {
    const timestamp = Date.parse(`${this.year.padStart(4, '0')}-${this.month}-${this.day}`);
    if (Number.isNaN(timestamp) || this.day === '' || this.month === '' || this.year === '') {
      this.$emit('input', '');
    } else {
      this.$emit('input', timestamp);
    }
  }

  public initDate(dateField) {
    this.day = `${dateField ? new Date(dateField).getDate() : ''}`;
    this.month = `${dateField ? new Date(dateField).getMonth() + 1 : ''}`;
    this.year = `${dateField ? new Date(dateField).getFullYear() : ''}`;
  }

}
